import { useTranslation } from "react-i18next";
import "./PreparationPage.scss";
import { useEffect, useState } from "react";
import { useAmplitude } from "../../../context/AmplitudeContext";
import { useUID } from "../../../context/UIDContext";
import Button from "../../Button/Button";
import { CheckBox } from "../../CheckBox/CheckBox";
import { Trans } from "react-i18next";
import { FacePrepInfoIcon } from "../../icons/FacePrepInfoIcon";
import { useConfig } from "../../../context/ConfigContext";
import { HairPrepInfoIcon } from "../../icons/HairPrepInfoIcon";
import { useTracker } from "../../../context/TrackerContext";

export const PreparationPage = ({ onContinue }) => {
  const { t, i18n } = useTranslation("preparationPage");
  const { configData } = useConfig();
  const trackEvent = useAmplitude();
  const { itrack } = useTracker();
  const { uid } = useUID();
  const [isConsentMarked, setIsConsentMarked] = useState(false);
  const [isLicenseMarked, setIsLicenseMarked] = useState(false);
  const [isContinuePressed, setIsContinuePressed] = useState(false);

  useEffect(() => {
    itrack({ eventName: "visited_prep_page", trackerId: uid });
    trackEvent("visited_prep_page", uid);
  }, [uid, trackEvent, itrack]);

  return (
    <>
      <div className="validate-page-contents-wrapper">
        <div className="validate-content-area">
          <div className="validate-header-container">
            <h2 className="validate-title">{t("validate-title")}</h2>
            <p className="validate-sub-title">{t("validate-sub-title")}</p>
          </div>
          <div className="validate-images-container">
            {configData?.PreparationPageFlags?.iconName === "hairPrepIcon" ? (
              <HairPrepInfoIcon className={"validate-icon"} />
            ) : (
              <FacePrepInfoIcon className={"validate-icon"} />
            )}
          </div>
        </div>
        {!isContinuePressed && (
          <div className="licenses-wrapper">
            <div className="license-option">
              <CheckBox
                onClick={() => setIsConsentMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">{t("consent-text")}</p>
            </div>
            <div className="license-option">
              <CheckBox
                onClick={() => setIsLicenseMarked((prevValue) => !prevValue)}
              />
              <p className="validate-license-text">
                <Trans
                  ns="preparationPage"
                  i18nKey={"terms-text"}
                  components={{
                    click: (
                      <a
                        href={`https://www.iqonicai.com${i18n.language === "de" ? "/de" : ""}/terms-and-conditions`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="validate-license-text underline"
                      >
                        {/* */}
                      </a>
                    ),
                  }}
                />
              </p>
            </div>
          </div>
        )}
      </div>
      {!isContinuePressed && (
        <div className="preparation-page-button-wrapper">
          <Button
            text={t("continue")}
            onClick={() => {
              setIsContinuePressed(true);
              itrack({
                eventName: "pressed_continue_prep_page",
                trackerId: uid,
              });
              trackEvent("pressed_continue_prep_page", uid);
              setTimeout(() => onContinue(), 1000);
            }}
            disabled={!isConsentMarked || !isLicenseMarked}
          />
        </div>
      )}
    </>
  );
};
